// extracted by mini-css-extract-plugin
export var actionText = "_kh-4";
export var container = "_kh-0";
export var leftSection = "_kh-1";
export var rightSection = "_kh-2";
export var settingsButton = "_kh-6";
export var settingsIcon = "_kh-7";
export var shortcut = "_kh-5";
export var shortcutGroup = "_kh-3";